<template>
  <div id="app">
    <Header :nowPathName="nowPathName" v-show="viewFlag" ref="headers"/>
    <iframe src="./mms3D/index.html" id="iframe"></iframe>
    <div class="opery" :class="{operyActive:viewFlag}">

      <div class="view-box" :class="{rightLeaveTo:!flag}">
        <Btn @change="change"/>
        <router-view/>
      </div>
      <Transition name="left">
        <div class="nav" v-show="flag">
          <router-link v-for="(item,i) in list" :key="i" :to='item.path'>
            <div class="nav-box">
              <div class="nav-ico">
                <div class="bg"></div>
              </div>
              <div class="content">
                <div class="title">{{item.title}}</div>
                <p>{{item.english}}</p>
              </div>
            </div>
          </router-link>
        </div>
      </Transition>
    </div>
    <Video/>
    <div class="bg1"></div>
    <FloorFiltering/>
    <!--    <FloorBox :id="'dd'+i" v-for="(item,i) in floorData" :key="i" :item="item"/>-->
    <!--    <Elevator/>-->
    <!--    <Meter/>-->
  </div>
</template>
<script>
  import Header from '@/components/Header'
  import Btn from "@/components/Btn";
  import Video from "@/components/Video";
  import FloorFiltering from "@/components/FloorFiltering";
  import FloorBox from "@/components/FloorBox";
  import Elevator from "@/components/Elevator";
  import Meter from "@/components/Meter";

  export default {
    name: 'App',
    components: {
      Header,
      Btn,
      Video,
      FloorFiltering,
      FloorBox,
      Elevator,
      Meter
    },
    data() {
      return {
        list: [
          {
            title: '园区概况',
            path: '/parkOver',
            english: 'Park Homepage',
            ico: require('./assets/Homepage.png')
          },
          {
            title: '园区能耗',
            path: '/parkEnergy',
            english: 'Energy consumption',
            ico: require('./assets/Energy.png')
          }, {
            title: '园区安防',
            path: '/parkSecurity',
            english: 'Park Security',
            ico: require('./assets/Security.png')
          }, {
            title: '设备管理',
            path: '/deviceManagement',
            english: 'Eevice management',
            ico: require('./assets/Eevice.png')
          }
        ],
        flag: true,
        viewFlag: false,
        nowPathName: '',
        floorData: [
          {
            area: '56m',
            layer: '19层'
          }, {
            area: '49m',
            layer: '9层'
          }, {
            area: '10m',
            layer: '4层'
          }, {
            area: '300m',
            layer: '6层'
          }
        ]
      }
    },
    watch: {
      $route: {
        handler(val, oldval) {
          this.nowPathName = val.name
          if (val.fullPath == '/parkOver') {
            this.$store.state.flag = true;
          } else {

            this.$store.state.flag = false;
          }

          console.log(oldval.fullPath);
          switch (oldval.name) {
            case 'parkOver':
              document.getElementById('iframe').contentWindow.MMAPI.hide()
              break;
            case 'parkEnergy':
              //清除园区能耗三维效果
              document.getElementById('iframe').contentWindow.MMAPI.hide()
              window.parkenergyViewCancel();
              break;
            case 'parkSecurity':
              //清除园区安防三维效果
              document.getElementById('iframe').contentWindow.MMAPI.hide()
              window.parkSecurityViewCancel();
              break;
            case 'deviceManagement':
              window.recovery()
              window.deviceManagementViewCincle();
              document.getElementById('iframe').contentWindow.MMAPI.hide()
              document.getElementById('iframe').contentWindow.MMAPI.district(5);
              break;
          }
          switch (val.name) {
            case 'parkOver':

              if (this.$refs.headers.list[0].flag) {

                // document.getElementById('iframe').contentWindow.MMAPI.camera1111();
              } else {
                document.getElementById('iframe').contentWindow.MMAPI.sceneQH(0)
              }
              this.$refs.headers.chanageDay(0)
              document.getElementById('iframe').contentWindow.jiantou2()
              break;
            case 'parkEnergy':
              //清除园区能耗三维效果
              if (this.$refs.headers.list[0].flag) {
                document.getElementById('iframe').contentWindow.MMAPI.camera1111();
              } else {
                document.getElementById('iframe').contentWindow.MMAPI.sceneQH(0)
              }
              this.$refs.headers.chanageDay(0)
              document.getElementById('iframe').contentWindow.jiantou1()
              break;
            case 'parkSecurity':
              //清除园区安防三维效果
              if (this.$refs.headers.list[0].flag) {
                document.getElementById('iframe').contentWindow.MMAPI.camera1111();
              } else {
                document.getElementById('iframe').contentWindow.MMAPI.sceneQH(0)
              }
              this.$refs.headers.chanageDay(0)
              break;
          }
          if (val.name == 'deviceManagement') {
            setTimeout(() => {

              if (this.$refs.headers.list[0].flag) {
                document.getElementById('iframe').contentWindow.MMAPI.equipGL();
              } else {
                document.getElementById('iframe').contentWindow.MMAPI.sceneQH(0)
                setTimeout(() => {
                  document.getElementById('iframe').contentWindow.MMAPI.equipGL()
                }, 3000)
              }
              this.$refs.headers.chanageDay(0)
              document.getElementById('iframe').contentWindow.jiantou1()
            }, 500)
          }
        },
        // 深度观察监听
        deep: true
      }
    },
    mounted() {
      window.changShow = this.changShow
      if (this.$route.path == '/') {
        try {
          this.$router.push('/parkOver')
        } catch (e) {
          console.log(e);
        }
      }
    },
    methods: {
      change() {
        this.flag = !this.flag;
      },
      changShow() {
        this.viewFlag = true
      }
    }
  }
</script>
<style lang="less">
  .opery {
    opacity: 0;
  }

  .operyActive {
    opacity: 1;
  }

  .bg1 {
    width: 100vw;
    height: 100vh;
    background: url("./assets/bg.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }

  #iframe {
    width: 100%;
    height: 100%;
    border: none;
    position: absolute;
    top: 0;
    left: 0;
  }

  @font-face {
    font-family: rzzy;
    src: url('./assets/font/rzzy.TTF');
  }

  .right-enter-active,
  .right-leave-active {
    transition: all 1.5s;
  }

  .rightLeaveTo /* .fade-leave-active below version 2.1.8 */ {
    transform: translateX(370px);
  }

  .left-enter-active,
  .left-leave-active {
    transition: all 1.5s;
  }

  .left-enter, .left-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translateX(-230px);
  }

  #app {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    /*background: black;*/
  }

  .nav {
    position: absolute;
    background: url("./assets/nav-list.png") no-repeat;
    background-size: 100% 100%;
    width: 18px;
    height: 526px;
    left: 23px;
    top: 22%;
    z-index: 9;

    a {
      display: block;

      width: 148px;
      height: 85px;
      color: #fff;
      text-decoration: none;
      position: absolute;
      left: 30px;

      &.router-link-active {
        background: url("./assets/nav-active.png") no-repeat;
        background-size: 100% 100%;

        .nav-box {
          .content {
            .title {
              font-weight: bolder;
              color: transparent;
              background-image: linear-gradient(#ffffff, #c17e14);
              -webkit-background-clip: text;
            }
          }
        }

        &:nth-of-type(1) {
          .nav-ico {
            width: 30px;
            height: 24px;
            background: url("./assets/Homepage-active.png") no-repeat;
            background-size: 100% 100%;
          }
        }

        &:nth-of-type(2) {
          .nav-ico {
            background: url("./assets/Energy-active.png") no-repeat;
            background-size: 100% 100%;
          }
        }

        &:nth-of-type(3) {
          .nav-ico {
            background: url("./assets/Security-active.png") no-repeat;
            background-size: 100% 100%;
          }
        }

        &:nth-of-type(4) {
          .nav-ico {

            background: url("./assets/Eevice-active.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }

      &:nth-of-type(1) {
        .nav-ico {
          width: 30px;
          height: 24px;
          background: url("./assets/Homepage.png") no-repeat;
          background-size: 100% 100%;
        }

        top: -42.5px;
      }

      &:nth-of-type(2) {
        .nav-ico {
          width: 24px;
          height: 29px;
          background: url("./assets/Energy.png") no-repeat;
          background-size: 100% 100%;
        }

        top: 140px;
      }

      &:nth-of-type(3) {
        .nav-ico {
          width: 22px;
          height: 29px;
          background: url("./assets/Security.png") no-repeat;
          background-size: 100% 100%;
        }

        top: 302px;
      }

      &:nth-of-type(4) {
        .nav-ico {
          width: 20px;
          height: 20px;
          margin-top: 0px !important;
          background: url("./assets/Eevice.png") no-repeat;
          background-size: 100% 100%;
        }

        bottom: -42.5px;
      }

      .nav-box {
        display: flex;
        position: absolute;
        flex-wrap: nowrap;
        position: absolute;
        top: 28px;
        left: 38px;

        .nav-ico {
          margin-top: -5px;
          background-size: 100% 100% !important;
          position: relative;

          .bg {
            background: url("./assets/nav-bg.png") no-repeat;
            background-size: 100% 100%;
            width: 55px;
            height: 55px;
            position: absolute;
            top: -30px;
            left: -30px;
          }
        }

        .content {
          display: flex;
          flex-direction: column;
          align-items: start;
          margin-left: 5px;

          .title {
            font-size: 16px;
            font-weight: bold;
          }

          p {
            white-space: nowrap;
            transform: scale(0.8);
            margin-left: -5px;
          }
        }
      }
    }
  }

  .view-box {
    position: absolute;
    width: 356px;
    height: 930vh*0.098;
    background: url("./assets/view-box.png") no-repeat;
    background-size: 100% 100%;
    right: 14px;
    top: 82vh*0.098;
    padding-top: 8px;
    box-sizing: border-box;
    z-index: 9;
    transition: all 1.5s;
  }

  video::-webkit-media-controls-timeline {
    display: none;
  }
</style>
